import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-tooltip@3.7.0@rc-tooltip/es/index.js
// module id = 667
// module chunks = 0